module.exports = __webpack_public_path__ + "img/ebsa-rodape.e1529f6e.png";